import { useState, useEffect } from "react";
import { Card, Title, Label, Input, Overlay, ModalCloseButton } from "../CommonComponents/DataCard";
import Button from "../CommonComponents/Button";
import MessageModal from "../CommonComponents/MessageModal";
import { getPublisherById, updatePublisher } from "../../services/PublisherService";

function EditPublisherModal({ isOpen, onClose, id, onPublisherUpdated }) {
    const [form, setForm] = useState({ name: "", address: "", telephone: "", webSite: "" });
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [message, setMessage] = useState("");
    const [messageSuccess, setMessageSuccess] = useState(false);
    const [showMessageModal, setShowMessageModal] = useState(false);

    useEffect(() => {
        if (!isOpen || !id) return;
        setLoading(true);
        getPublisherById(id)
            .then(data => setForm({
                name: data.name || "",
                address: data.address || "",
                telephone: data.telephone || "",
                webSite: data.webSite || "",
            }))
            .catch(err => {
                setMessage(err.message || "Greška pri učitavanju izdavača");
                setMessageSuccess(false);
                setShowMessageModal(true);
            })
            .finally(() => setLoading(false));
    }, [isOpen, id]);

    if (!isOpen) return null;

    const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

    const handleSave = async () => {
        setSaving(true);
        try {
            const updated = await updatePublisher(id, form);
            setMessage("Izdavač uspješno ažuriran!");
            setMessageSuccess(true);
            setShowMessageModal(true);
            if (onPublisherUpdated) onPublisherUpdated(updated);
        } catch (err) {
            setMessage(err.message || "Greška pri ažuriranju izdavača");
            setMessageSuccess(false);
            setShowMessageModal(true);
        } finally {
            setSaving(false);
        }
    };

    return (
        <Overlay onClick={onClose} style={{ alignItems: "flex-start", padding: "2rem 1rem", overflowY: "auto", boxSizing: "border-box" }}>
            <MessageModal
                isOpen={showMessageModal}
                onClose={() => { setShowMessageModal(false); if (messageSuccess) onClose(); }}
                title="Uređivanje izdavača"
                variant={messageSuccess ? "success" : "error"}
            >
                {message}
            </MessageModal>

            <div onClick={e => e.stopPropagation()} style={{ width: "fit-content" }}>
                <Card style={{ position: "relative" }}>
                <ModalCloseButton onClick={onClose} title="Zatvori" style={{ position: "absolute", top: "0.75rem", right: "0.75rem" }}>×</ModalCloseButton>
                    <Title>Uredi izdavača</Title>

                    {loading ? <p>Učitavanje...</p> : (
                        <>
                            <Label>Naziv:</Label>
                            <Input name="name" value={form.name} onChange={handleChange} />

                            <Label>Adresa:</Label>
                            <Input name="address" value={form.address} onChange={handleChange} />

                            <Label>Telefon:</Label>
                            <Input name="telephone" value={form.telephone} onChange={handleChange} />

                            <Label>Web mjesto:</Label>
                            <Input name="webSite" value={form.webSite} onChange={handleChange} />

                            <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px", marginTop: "16px" }}>
                                <Button akcija={onClose} tekst="Odustani" />
                                <Button akcija={handleSave} tekst={saving ? "Spremanje..." : "Spremi"} />
                            </div>
                        </>
                    )}
                </Card>
            </div>
        </Overlay>
    );
}

export default EditPublisherModal;
